<app-megamenu></app-megamenu>

<div class="service-page">
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Rodent Control Services</h1>
        <p class="hero-subtitle">Comprehensive mouse and rat control with humane removal methods and effective prevention strategies.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Rodent Control
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <div class="container">
      <h2>Professional Rodent Elimination</h2>
      <p>Mice and rats can cause property damage, contaminate food, and spread diseases. Our comprehensive rodent control program eliminates current infestations and prevents future problems.</p>
      
      <div class="features-grid">
        <div class="feature-card">
          <mat-icon>cruelty_free</mat-icon>
          <h3>Humane Methods</h3>
          <p>Safe and humane rodent removal methods that are effective and ethical</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>home_repair_service</mat-icon>
          <h3>Entry Point Sealing</h3>
          <p>Comprehensive sealing of entry points to prevent future infestations</p>
        </div>
        
        <div class="feature-card">
          <mat-icon>monitor</mat-icon>
          <h3>Monitoring Systems</h3>
          <p>Strategic placement of monitoring stations for ongoing protection</p>
        </div>
      </div>
    </div>
  </div>

  <div class="cta-section">
    <div class="container">
      <h2>Stop Rodent Problems</h2>
      <p>Don't let mice and rats damage your property. Our proven rodent control methods eliminate infestations safely and effectively.</p>
      <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
        <mat-icon>pest_control</mat-icon>
        Schedule Treatment
      </button>
    </div>
  </div>
</div>

<app-footer></app-footer>